import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import PropTypes from 'prop-types';
import { useItemListContext } from './ItemContext';
import ContentLoading from './ContentLoading';
import ItemTable from './ItemTable';

const Container = ({ metaOverrideSet }) => {
  const { itemsCollection, loadingError } = useItemListContext();

  return (
    <DataContainer
      loading={!itemsCollection}
      loadingError={loadingError}
      skeleton={ContentLoading}
      component={ItemTable}
      componentProps={{
        metaOverrideSet,
      }}
    />
  );
};

Container.propTypes = {
  metaOverrideSet: PropTypes.object,
};

Container.defaultProps = {
  metaOverrideSet: null,
};

export default Container;
